import ScheduleMain from 'features/schedule/components/ScheduleMain/ScheduleMain';
import React from 'react';
import { usePageTitle } from 'utils/locationHelpers';
import './SchedulePage.scss';

export default function SchedulePage() {
    usePageTitle('Schedule');
    return <ScheduleMain />;
}
